import {customAttribute, autoinject} from "aurelia-framework";
import "jquery";

@autoinject
@customAttribute('blur-on-escape')
export class BlurOnEscape
{
    private element: Element;
    private onEscape: EventListener;

    constructor(element:Element)
    {
        this.element = element;
        this.onEscape = (event:KeyboardEvent) => {
            if (event.keyCode === 27) {
                event.stopPropagation();
                $(element).blur();
                return false;
            }
            return true;
        };
    }

    attached()
    {
        this.element.addEventListener("keyup", this.onEscape);
    }

    detached()
    {
        this.element.removeEventListener("keyup", this.onEscape);
    }
}